import React from 'react';
import { Button } from 'react-bootstrap';

class StatusButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      server: props.server
    };
    this.handleClick = this.handleClick.bind(this);
  }

  render() {
    if (this.state.server.running === 'false') {
      return (
        <Button bsStyle="danger" onClick={this.handleClick}>
          Offline
        </Button>
      );
    } else if (this.state.server.running === 'true') {
      return (
        <Button bsStyle="success" onClick={this.handleClick}>
          Running
        </Button>
      );
    }
  }

  handleClick() {
    fetch('https://api.redwood-guild.com/servers', {
      method: 'POST',
      body: JSON.stringify(this.state.server)
    })
      .then(res => res.json())
      .then(
        result => {
          var server = this.state.server;
          if (result.success === 'true') {
            server.running = 'true';
          } else {
            server.running = 'false';
          }

          this.setState({
            server: server
          });
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        error => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      );
  }
}

export default StatusButton;



// WEBPACK FOOTER //
// ./src/components/ServersList/StatusButton/StatusButton.js